var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLsqClone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5494_45016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 6.6665V3.99984C15.9998 3.64622 15.8594 3.30708 15.6093 3.05703C15.3593 2.80698 15.0201 2.6665 14.6665 2.6665H3.99984C3.64622 2.6665 3.30708 2.80698 3.05703 3.05703C2.80698 3.30708 2.6665 3.64622 2.6665 3.99984V14.6665C2.6665 15.0201 2.80698 15.3593 3.05703 15.6093C3.30708 15.8594 3.64622 15.9998 3.99984 15.9998H6.6665V7.99984C6.6665 7.64621 6.80698 7.30708 7.05703 7.05703C7.30708 6.80698 7.64621 6.6665 7.99984 6.6665H15.9998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 8H9.33333C8.97971 8 8.64057 8.14048 8.39052 8.39052C8.14048 8.64057 8 8.97971 8 9.33333V20C8 20.3536 8.14048 20.6928 8.39052 20.9428C8.64057 21.1929 8.97971 21.3333 9.33333 21.3333H20C20.3536 21.3333 20.6928 21.1929 20.9428 20.9428C21.1929 20.6928 21.3333 20.3536 21.3333 20V9.33333C21.3333 8.97971 21.1929 8.64057 20.9428 8.39052C20.6928 8.14048 20.3536 8 20 8ZM18.6667 15.3333H15.3333V18.6667H14V15.3333H10.6667V14H14V10.6667H15.3333V14H18.6667V15.3333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5494_45016"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLsqClone);
export default __webpack_public_path__ + "static/media/lsq_clone.2992347d2ca5ee8d2bac819a6735798a.svg";
export { ForwardRef as ReactComponent };